<div *ngIf="supplierId" class="card mt-2">
    <div *ngIf="loading" class="d-flex justify-content-center">
        <H5 class="text-warning my-5">Chargement en cours...</H5>
    </div>
    <div *ngIf="!loading" class="card-body">

        <div class="row">
            <div class="col-8 offset-2">
                <table class="table-depenses my-3">
                    <thead>
                        <tr class="text-center">
                            <th></th>
                            <th colspan="2">Commandes HT</th>
                            <th colspan="2">
                                <div class="d-flex flex-column">
                                    <span>Factures HT</span>
                                    <small>(Date pièce)</small>
                                </div>
                            </th>
                            <th colspan="2">
                                <div class="d-flex flex-column">
                                    <span>Factures HT</span>
                                    <small>(Date comptable)</small>
                                </div>
                            </th>
                        </tr>
                        <tr class="text-center">
                            <th></th>
                            <th>Montant</th>
                            <th>Nombre</th>
                            <th>Montant</th>
                            <th>Nombre</th>
                            <th>Montant</th>
                            <th>Nombre</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of lstDepenses">
                            <td class="text-left pl-1"><label class="control-label">{{item.Annee}}</label></td>
                            <td class="text-right text-currency pr-1">{{item.CdeMtHt | currency}}</td>
                            <td class="text-right text-currency pr-1">{{item.CdeCpt | number:'1.0-0':'fr'}}</td>
                            <td class="text-right text-currency pr-1">{{item.FacMtHt | currency}}</td>
                            <td class="text-right text-currency pr-1">{{item.FacCpt | number:'1.0-0':'fr'}}</td>
                            <td class="text-right text-currency pr-1">{{item.CtaMtHt | currency}}</td>
                            <td class="text-right text-currency pr-1">{{item.CtaCpt | number:'1.0-0':'fr'}}</td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>